import request from '@/router/axios';

// 控制记录 列表
export const getList = (current, size, params, search) => {
  return request({
    url: '/api/blade-system/dept/static-policy-management',
    method: 'post',
    data: {
        ...params,
        ...search,
        current,
        size
    }
  })
}
// 已管控 列表
export const getControlDept = (current, size, params, search) => {
  return request({
    url: '/api/blade-system/dept/getControlDept',
    method: 'post',
    data: {
        ...params,
        ...search,
        current,
        size
    }
  })
}
// 已管控 列表
export const updateList = (data) => {
  return request({
    url: '/api/blade-system/dept/updateList',
    method: 'post',
    data: {
      ...data
    }
  })
}
